import { isEmptyString } from '../../../helpers/string.utils';
import { isNil } from '@alk/core';
import { SpotPriceRequest, SpotPriceRequestWithClient } from '../../../interfaces';

export function validatePadRequest(request: SpotPriceRequest): null | string {
    if (isNil(request.quantity)) {
        return '[ESP_PRICE_SERVICE#validatePadRequest] quantity not set';
    }

    if (isEmptyString(request.ccyPair)) {
        return '[ESP_PRICE_SERVICE#validatePadRequest] ccyPair not set';
    }

    return null;
}

export function accumulateRequests(
    currentToken: string,
    newRequest: SpotPriceRequestWithClient,
    createFeed: (PriceRequest) => string,
    updateFeed: (string, PriceRequest) => void,
    removeFeed: (string) => void,
): string{
    //stoped called if no request
    if (!Boolean(newRequest)) {
        if (Boolean(currentToken)) {
            removeFeed(currentToken);
        }

        return null;
    }

    //if request not null
    if (Boolean(currentToken)) { //update if feed already created
        updateFeed(currentToken, newRequest);
    } else { //create feed if not created
        return createFeed(newRequest);
    }

    return currentToken;
}
